import React, { useEffect } from 'react'
import ComingSoon from 'components/ComingSoon'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { useParams } from 'react-router'
import { Location } from 'models/location'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

const WaiverSigneesPage = () => {
  const params: Location = useParams()
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.WAIVERS_PAGE_EVENT, { location: params.locationId })
  }, [])

  return (
    <FacilityFormTemplate>
      <ComingSoon />
    </FacilityFormTemplate>
  )
}

export default WaiverSigneesPage
